import { UtmParamsControl } from './UtmParamsControl';

export default UtmParamsControl;
